module.exports = __webpack_public_path__ + "img/logo-topcvp.69197702.png";